export const validarConfDecimales = (conf) => {
    if (conf) {
        let decimales = conf.conf_modena_con_3_decimales ? 3 : 2
        return decimales
    } else {
        return 2
    }
}
